import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class ToggleListItem extends BaseExtension {
  get schema(): NodeSpec {
    return {
      content: 'toggle_block_heading toggle_block_content',
      group: 'block',
      isolating: true,
      parseDOM: [],
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
